import { Link } from 'react-router-dom'

import DocPage from '../components/DocPage.jsx'
import { childSections, documentation } from '../content.js'

// /docs — the index. P6-104.
//
// 🔴 IT WAS THE WHOLE OF THE DOCUMENTATION AND IT IS NOW A FRONT DOOR. Jordan:
// "When I wanted a 'page' per feature, that is supposed to be on the site.
// Everything shouldn't be crammed into one page." What is left here is the prose
// that belongs to no single feature — how to find a command, and what to do when
// something looks wrong — plus this directory.
//
// 🔴 THE DIRECTORY IS DERIVED FROM THE REGISTRY, NEVER TYPED. childSections()
// reads content-src/sections.json, which is the same file that creates the
// routes and the same file the guard derives the crew set from. A hand-written
// list here would be a second registry, and the first page it disagreed with
// would be a link to a 404 — or worse, a feature page nobody could find because
// nothing linked to it. Adding a feature page is one entry in that file.
//
// ⚠️ NOT `d2d-stagger`. The landing page's public index carries it (P6-183
// retired the doors that used to) and the generator caps doors at six for
// exactly that reason ("the stagger caps at six items, past which the seventh
// row is waiting on choreography"). There are five feature pages today and
// there will be more, so this grid animates as a whole rather than pretending
// to a stagger that was designed for a handful of cards.
//
// A slot IS linked, deliberately. The Slot page exists so "not built yet" is a
// visible, honest state with a stable URL rather than a 404, and a card that
// says "Not built yet" and then refuses to open is worse than one that opens
// onto a page saying what it is waiting for. The flag is on the card so nobody
// has to click to find out.

function Directory() {
  const children = childSections('docs')

  return (
    <nav className="d2d-doors d2d-doors--index" aria-label="Documentation pages">
      {children.map((section) => (
        <Link key={section.id} to={section.path} className="d2d-door">
          <span className="d2d-door__title">{section.title}</span>
          <span className="d2d-door__body">{section.summary}</span>
          {section.status === 'slot' ? (
            <span
              className="d2d-door__pending d2d-micro"
              data-testid={`docs-pending-${section.id}`}
            >
              Not built yet
            </span>
          ) : (
            <span className="d2d-door__action d2d-micro">Read &rarr;</span>
          )}
        </Link>
      ))}
    </nav>
  )
}

export default function DocsIndex() {
  return <DocPage doc={documentation} directory={<Directory />} />
}
